var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpin4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_book-saved",
    "data-name": "vuesax/linear/book-saved",
    transform: "translate(0 -253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "book-saved",
    transform: "translate(0 253)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.833,2.593v15.59a2.654,2.654,0,0,1-2.247,2.557l-.426.052a32.887,32.887,0,0,0-9.636,3.177,1.4,1.4,0,0,1-1.24,0l-.052-.026a33.186,33.186,0,0,0-9.61-3.152l-.375-.052A2.654,2.654,0,0,1,0,18.184V2.58A2.541,2.541,0,0,1,2.79.01a24.228,24.228,0,0,1,9.119,3.023l.323.194a1.431,1.431,0,0,0,1.369,0l.22-.142a19.917,19.917,0,0,1,2.971-1.46v5.27l2.583-1.718,2.583,1.718V.152a10.025,10.025,0,0,1,.995-.129h.077A2.545,2.545,0,0,1,25.833,2.593Z",
    transform: "translate(2.583 3.439)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0V19.375",
    transform: "translate(15.5 7.091)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.167,0V6.742L2.583,5.025,0,6.742V1.472A26.106,26.106,0,0,1,5.167,0Z",
    transform: "translate(19.375 3.591)",
    fill: "none",
    stroke: "#ed2f59",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H31V31H0Z",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpin4);
export default __webpack_public_path__ + "static/media/spin4.97bc7dac000fa462257f1ffb8f2eac56.svg";
export { ForwardRef as ReactComponent };